var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c("StepTitle", { attrs: { "step-num": "1", title: "创建账号" } }),
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "orgForm",
          attrs: {
            model: _vm.ruleForm,
            rules: _vm.rules,
            "label-width": "80px"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "头像", prop: "headImg" } },
            [
              _c(
                "el-upload",
                {
                  staticClass: "avatar-uploader",
                  attrs: {
                    action: "#",
                    "show-file-list": false,
                    "on-change": _vm.onChange,
                    "auto-upload": true,
                    "http-request": _vm.upLoadFile,
                    "before-upload": _vm.beforeAvatarUpload
                  }
                },
                [
                  _vm.ruleForm.headImg
                    ? _c("img", {
                        staticClass: "avatar",
                        attrs: { src: _vm.ruleForm.headImg }
                      })
                    : _c("i", {
                        staticClass: "el-icon-plus avatar-uploader-icon"
                      })
                ]
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "账号", prop: "username" } },
            [
              _c("el-input", {
                attrs: {
                  size: "small",
                  label: "描述文字",
                  placeholder: "请输入手机号"
                },
                model: {
                  value: _vm.ruleForm.username,
                  callback: function($$v) {
                    _vm.$set(_vm.ruleForm, "username", $$v)
                  },
                  expression: "ruleForm.username"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "密码", prop: "password" } },
            [
              _c("el-input", {
                attrs: {
                  size: "small",
                  label: "描述文字",
                  placeholder: "请输入密码"
                },
                model: {
                  value: _vm.ruleForm.password,
                  callback: function($$v) {
                    _vm.$set(_vm.ruleForm, "password", $$v)
                  },
                  expression: "ruleForm.password"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "用户角色", prop: "roleId" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    size: "small",
                    clearable: "",
                    placeholder: "请选择"
                  },
                  model: {
                    value: _vm.ruleForm.roleId,
                    callback: function($$v) {
                      _vm.$set(_vm.ruleForm, "roleId", $$v)
                    },
                    expression: "ruleForm.roleId"
                  }
                },
                _vm._l(_vm.roles, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.submitForm("ruleForm")
                    }
                  }
                },
                [_vm._v("下一步")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }